<template>
	<div class="exportReport" id="pdfPrint">
		<!-- <el-button type="primary" @click="onPrint()" class="noprint">打印</el-button> -->
		<el-button type="primary" @click="getPdf()" class="noprint">导出</el-button>

		<div class="topdiv"></div>

		<div class="div1">
			<ul>
				<li>订单编号:{{form.recordCode}}</li>
				<li>充检站:{{form.stationName}}</li>
				<li>充电起始时间:{{form.beginTime}}</li>
				<li>充检桩编码:{{form.pileCode}}</li>
				<li>充电结束时间:{{form.endTime}}</li>
				<li>充检枪号:{{form.gunNo}}</li>
				<li>车牌号:{{form.plateNumber}}</li>
				<li>车型:{{form.carType}}</li>
				<li>VIN:{{form.vin}}</li>
				<li>电池类型:{{form.batteryType}}</li>
			</ul>
			<div class="scorediv">
				<span class="sp1">电池健康评估综合得分</span>
				<b>{{form.score}}</b>
			</div>
			<p class="sp2">{{form.suggest}}电池健康评估综合得分</p>
		</div>
		<div class="div2">
			<div id="radar" class="allnav"></div>
			<div id="radar2" class="allnav"></div>
			<div id="radar3" class="allnav"></div>

			<img id="radarimg" src="" alt="" class="allnav">
			<img id="radar2img" src="" alt="" class="allnav">
			<img id="radar3img" src="" alt="" class="allnav">

			<p class="sp1">一致性分析得分</p>
			<p class="sp2">容量特性分析得分</p>
			<p class="sp3">能量特性分析得分</p>
		</div>
		<div class="div3">
			<p>【热失控风险】</p>
			<div id="thermalRunaway" class="allnav"></div>
			<img id="thermaldiv" src="" alt="" class="allnav">
			<ul>
				<li><span></span>正常</li>
				<li><span></span>一级告警</li>
				<li><span></span>二级告警</li>
				<li><span></span>三级告警</li>
			</ul>
		</div>
		<!-- 单体电压变化曲线 -->
		<div class="div4">
			<div class="title">
				<p>【单体电压变化曲线】</p>
				<p>最高电压：是指充电过程中电压最高的单体电压值</p>
				<p>最低电压：是指充电过程中电压最低的单体电压值</p>
			</div>
			<div id="voltage" class="allnav"></div>
			<img id="voltageimg" src="" alt="" class="allnav">
		</div>
		<!-- 单体温度变化曲线 -->
		<div class="div5">
			<div class="title">
				<p>【单体温度变化曲线】</p>
				<p>最大温度：是指充电过程中温度最高的单体温度值</p>
				<p>最小温度：是指充电过程中温度最低的单体温度值</p>
			</div>
			<div id="temperature" class="allnav"></div>
			<img id="temperatureimg" src="" alt="" class="allnav">

		</div>
		<!-- 电压极差变化曲线 -->
		<div class="div6">
			<div class="title">
				<p>【电压极差变化曲线】</p>
				<p>电压极差：电压极差是指同一时间内最高单体电压和最低单体电压的差值</p>
				<p>一般情况下，电压极差越小，代表电池的电压一致性越好</p>
			</div>
			<div id="voltageRange" class="allnav"></div>
			<img id="voltageRangeimg" src="" alt="" class="allnav">
		</div>
		<!-- 温度极差变化曲线 -->
		<div class="div7">
			<div class="title">
				<p>【温度极差变化曲线】</p>
				<p>温度极差：温度极差是指同一时间内最高单体温度和最低单体温度的差值</p>
				<p>一般情况下，温度极差越小，代表电池的温度一致性越好</p>
			</div>
			<div id="temperatureRange" class="allnav"></div>
			<img id="temperatureRangeimg" src="" alt="" class="allnav">
		</div>


	</div>
</template>

<script>
	import html2Canvas from 'html2canvas';
	import JsPDF from 'jspdf';
	import 'echarts-liquidfill'

	export default {
		props: ['pileCode', 'recordCode', 'formPrint'], //父/子间通讯的桥梁
		data() {
			return {
				pileCodeStr: '',
				recordCodeStr: '',
				AuthorizationStr: '',
				form: {
					failureMetrics: ['', '', '', '', '', '']
				},
				radarchart1: '',
				radarchart2: '',
				radarchart3: '',
				voltagechart: '',
				tempchart: '',
				voltagechart2: '',
				tempchart2: '',

				voltageRangeList: [],
				tempRangeList: [],
			}
		},
		mounted() {
			let _this = this;
			var query = this.$route.query;
			_this.pileCodeStr = query.pileCode;
			_this.recordCodeStr = query.recordCode;
			_this.AuthorizationStr = query.Authorization;
			if (JSON.stringify(query) != '{}') {
				_this.onReportPreview();
			}


			this.$nextTick(() => {

				// _this.maxTempList = [10, 11, 13, 11, 12, 12, 9];
				// _this.minTempList = [1, 20, 2, 5, 3, 2, 0];
				// _this.tempTimeList = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];

				// _this.maxVoltageList = [10, 11, 13, 11, 12, 12, 9];
				// _this.minVoltageList = [1, 20, 2, 5, 3, 2, 0];
				// _this.voltageTimeList = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];

			})





		},
		methods: {
			onPrint: function() {
				window.print();
			},
			// 车检报告预览数据
			onReportPreview: function() {
				let _this = this;
				this.$api.post('/order/report/preview', {
						// Authorization: _this.AuthorizationStr == '' ? sessionStorage.getItem('Authorization') :
						// 	_this.AuthorizationStr,
						pileCode: _this.pileCode == undefined ? _this.pileCodeStr : _this.pileCode, //充电桩编号
						recordCode: _this.recordCode == undefined ? _this.recordCodeStr : _this.recordCode, //订单编号
					},
					function(response, context) {
						// _this.$message({
						// 	showClose: true,
						// 	message: "车检报告预览数据：" + response.message,
						// 	type: response.code == "200" ? 'success' : 'error'
						// });
						if (response.code == "200") {
							_this.onformat(response.data);
						}
					}
				);
			},

			onRadar: function() {
				let _this = this;
				_this.radarchart1 = this.$echarts.init(document.getElementById('radar'));

				let option = {

					title: {
						show: true,
						text: 98.67,
						top: 'center',
						left: 'center',
						color: '#99D2FD',
						fontSize: 26,
					},
					radar: {
						// shape: 'circle',
						center: ['50%', '50%'],
						radius: '55%',
						axisLine: {
							show: true,
							//指向外圈文本的分隔线样式
							lineStyle: {
								color: '#e5e5e5',
								width: 1,
							},
						},
						splitLine: {
							lineStyle: {
								width: 1,
								color: '#e5e5e5',
							},
						},
						splitArea: {
							show: false,
						},
						indicator: [{
								name: '电压',
								max: 100,
								color: '#96D3FD',
								axisLabel: {
									show: true
								},
							},
							{
								name: '温度',
								max: 100,
								color: '#96D3FD'
							},
							{
								name: '电量',
								max: 100,
								color: '#96D3FD'
							},
							{
								name: '容量',
								max: 100,
								color: '#96D3FD'
							},
							{
								name: '内阻',
								max: 100,
								color: '#96D3FD'
							}
						]
					},
					series: [{
						type: 'radar',
						animation: false,
						symbolSize: 0,
						data: [{
							// value: [],
							value: [100, 100, 100, 100, 100, 100],
						}],

						lineStyle: {
							color: "#99D2FD",
							width: 3
						}
					}]
				};

				_this.radarchart1.setOption(option, true);
				window.addEventListener("resize", function() {
					_this.radarchart1.resize();
				});
				var imgSrc = _this.radarchart1.getDataURL();
				$('#radarimg').attr('src', imgSrc).show();
				$('#radarimg').css('display', 'none');
			},
			onRadar2: function() {
				let _this = this;
				_this.radarchart2 = this.$echarts.init(document.getElementById('radar2'));
				let option2 = {
					series: [{
						axisLine: {
							lineStyle: {
								width: 15,
								color: [
									[0.3, '#fd666d'],
									[0.7, '#ffaa00'],
									[1, '#00aa00']
								]
							}
						},
						animation: false,
						type: 'gauge',
						progress: {
							show: true,
							width: 18
						},
						axisTick: {
							show: false
						},
						splitLine: {
							length: 5,
							lineStyle: {
								width: 2,
							}
						},
						axisLabel: {
							distance: 5,
							fontSize: 12
						},
						anchor: {
							show: true,
							showAbove: true,
							size: 25,
							itemStyle: {
								borderWidth: 10
							}
						},
						title: {
							show: false
						},
						detail: {
							valueAnimation: true,
							fontSize: 40,
							offsetCenter: [0, '70%']
						},
						data: [{
							value: _this.form.capacityMetrics
						}]
					}]
				};
				var value = 0.5;
				var data = [value];
				var option = {
					series: [{
							type: 'liquidFill',
							radius: '55%',
							center: ['50%', '45%'],
							color: [{
								type: 'linear',
								x: 0,
								y: 0,
								x2: 0,
								y2: 1,
								colorStops: [{
										offset: 0,
										color: '#96D3FD',
									},
									{
										offset: 1,
										color: '#E8F5FD',
									},
								],
								globalCoord: false,
							}, ],
							data: [value], // data个数代表波浪数
							backgroundStyle: {
								borderWidth: 1,
								color: '#F7FBFE',
							},
							label: {
								//标签设置
								position: ['50%', '30%'],
								formatter: _this.form.capacityMetrics + '', //显示文本,
								fontSize: '32px', //文本字号,
								color: '#98D3FD',
							},
							outline: {
								show: true,
								borderDistance: 0,
								itemStyle: {
									borderWidth: 4,
									borderColor: '#99D2FD',
								},
							},
						},


					],
				};
				_this.radarchart2.setOption(option);
				window.addEventListener("resize", function() {
					_this.radarchart2.resize();
				});
				var imgSrc = _this.radarchart2.getDataURL();
				$('#radar2img').attr('src', imgSrc).show();
				$('#radar2img').css('display', 'none');
				setTimeout(function() {
					var imgSrc = _this.radarchart2.getDataURL();
					$('#radar2img').attr('src', imgSrc).show();
					$('#radar2img').css('display', 'none');
				}, 2000);

			},
			onRadar3: function() {
				let _this = this;
				_this.radarchart3 = this.$echarts.init(document.getElementById('radar3'));
				let option3 = {
					series: [{
						type: 'gauge',
						animation: false,
						axisLine: {
							lineStyle: {
								width: 15,
								color: [
									[0.3, '#fd666d'],
									[0.7, '#ffaa00'],
									[1, '#00aa00']
								]
							}
						},
						pointer: {
							itemStyle: {
								color: 'auto'
							}
						},
						axisTick: {
							distance: -15,
							length: 8,
							lineStyle: {
								width: 2
							}
						},
						splitLine: {
							distance: -15,
							length: 15,
							lineStyle: {
								width: 2
							}
						},
						axisLabel: {
							color: 'auto',
							distance: 5,
							fontSize: 12
						},
						detail: {
							valueAnimation: true,
							formatter: '{value}',
							color: 'auto',
							fontSize: 40,
							offsetCenter: [0, '70%']

						},
						data: [{
							value: _this.form.energyIndicator
						}]
					}]
				};
				var value = 0.5;
				var data = [value];
				var option2 = {
					series: [{
							type: 'liquidFill',
							radius: '55%',
							center: ['50%', '45%'],
							color: [{
								type: 'linear',
								x: 0,
								y: 0,
								x2: 0,
								y2: 1,
								colorStops: [{
										offset: 0,
										color: '#EEA77F',
									},
									{
										offset: 1,
										color: '#ffcd8f',
									},
								],
								globalCoord: false,
							}, ],
							data: [value], // data个数代表波浪数
							backgroundStyle: {
								borderWidth: 1,
								color: '#F7FBFE',
							},
							label: {
								//标签设置
								position: ['50%', '30%'],
								formatter: _this.form.energyIndicator + '', //显示文本,
								fontSize: '32px', //文本字号,
								color: '#EEA77F',
							},
							outline: {
								show: true,
								borderDistance: 0,
								itemStyle: {
									borderWidth: 4,
									borderColor: '#EEA77F',
								},
							},
						},


					],
				};

				var value = 0.50;
				var data = [value, value, value];
				var option = {
					series: [{
						type: 'liquidFill',
						radius: '58%',
						center: ['50%', '45%'],
						shape: 'diamond',
						data: data,
						backgroundStyle: {
							color: '#F7FBFE',
						},
						outline: {
							borderDistance: 4,
							itemStyle: {
								borderWidth: 5,
								borderColor: "#F0A782",
								shadowBlur: 0,
							}
						},
						color: ['#F5C8AB', '#EFA983', '#EFA781'],
						label: {
							//标签设置
							position: ['50%', '30%'],
							formatter: _this.form.energyIndicator + '', //显示文本,
							fontSize: '32px', //文本字号,
							color: '#F0A782',
						},
					}]
				};

				_this.radarchart3.setOption(option);
				window.addEventListener("resize", function() {
					_this.radarchart3.resize();
				});
				var imgSrc = _this.radarchart3.getDataURL();
				$('#radar3img').attr('src', imgSrc).show();
				$('#radar3img').css('display', 'none');
				setTimeout(function() {
					var imgSrc = _this.radarchart3.getDataURL();
					$('#radar3img').attr('src', imgSrc).show();
					$('#radar3img').css('display', 'none');
				}, 2000);
			},

			//电压
			onVoltage: function() {
				let _this = this;
				_this.voltagechart = this.$echarts.init(document.getElementById('voltage'));
				var option = {
					title: {
						show: false,
						text: '单体电压变化曲线',
						left: 'center',
					},
					tooltip: {
						trigger: 'axis',
						axisPointer: {
							lineStyle: {}
						}
					},
					legend: {
						icon: 'rect',
						itemWidth: 8,
						itemHeight: 8,
						itemGap: 10,
						data: ['最高电压', '最低电压'],
						right: '10px',
						top: '0px',
						textStyle: {
							fontSize: 12,
						}
					},
					grid: {
						x: 50,
						y: 50,
						x2: 50,
						y2: 40
					},
					xAxis: [{
						type: 'category',
						boundaryGap: false,
						axisTick: {
							show: false,
						},
						axisLine: {
							lineStyle: {
								color: '#909399'
							}
						},
						axisLabel: {
							formatter: function(value, index) {
								var date = new Date(value);
								var texts = [(date.getHours()), date.getMinutes(), date.getSeconds()];
								return texts.join(':');
							}
						},
						data: _this.voltageTimeList
					}],
					yAxis: [{
						type: 'value',
						// boundaryGap: [0, '100%'],
						name: '单位（ V ）',
						nameLocation: 'center',
						nameTextStyle: {
							padding: 5
						},
						axisTick: {
							show: false
						},
						axisLine: {
							lineStyle: {
								color: '#57617B'
							}
						},
						axisLabel: {
							margin: 10,
							fontSize: 12,
							formatter: '{value}'
						},
						splitLine: {
							lineStyle: {
								color: '#e5e5e5'
							}
						}
					}],

					series: [{
							name: '最高电压',
							type: 'line',
							smooth: true,
							animation: false,
							lineStyle: {
								width: 2
							},
							yAxisIndex: 0,
							itemStyle: {
								color: '#01B5C4'
							},
							data: _this.maxVoltageList
						},
						{
							show: false,
							name: '最低电压',
							type: 'line',
							smooth: true,
							animation: false,
							lineStyle: {
								width: 2
							},
							yAxisIndex: 0,
							itemStyle: {
								color: '#00CC89'
							},
							data: _this.minVoltageList
						}
					],
				};
				_this.voltagechart.setOption(option);
				window.addEventListener("resize", function() {
					_this.voltagechart.resize();
				});

				var imgSrc = _this.voltagechart.getDataURL();
				console.log(imgSrc)
				$('#voltageimg').attr('src', imgSrc).show();
				$('#voltageimg').css('display', 'none');
			},
			//温度
			onTemperature: function() {
				let _this = this;
				_this.tempchart = this.$echarts.init(document.getElementById('temperature'));
				var option = {
					title: {
						show: false,
						text: '单体温度变化曲线',
						left: 'center',
					},
					tooltip: {
						trigger: 'axis',
						axisPointer: {
							lineStyle: {}
						}
					},
					legend: {
						icon: 'rect',
						itemWidth: 8,
						itemHeight: 8,
						itemGap: 10,
						data: ['最高温度', '最低温度'],
						right: '10px',
						top: '0px',
						textStyle: {
							fontSize: 12,
						}
					},
					grid: {
						x: 50,
						y: 50,
						x2: 45,
						y2: 40
					},
					xAxis: [{
						type: 'category',
						boundaryGap: false,
						axisTick: {
							show: false,
						},
						axisLine: {
							lineStyle: {
								color: '#909399'
							}
						},
						axisLabel: {
							formatter: function(value, index) {
								var date = new Date(value);
								var texts = [(date.getHours()), date.getMinutes(), date.getSeconds()];
								return texts.join(':');
							}
						},
						data: _this.tempTimeList,
					}],
					yAxis: [{
						type: 'value',
						name: '单位（ ℃ ）',
						nameLocation: 'center',
						nameTextStyle: {
							padding: 10
						},
						axisTick: {
							show: false
						},
						axisLine: {
							lineStyle: {
								color: '#57617B'
							}
						},
						axisLabel: {
							margin: 10,
							fontSize: 12,
							formatter: '{value}'
						},
						splitLine: {
							lineStyle: {
								color: '#e5e5e5'
							}
						}
					}],
					series: [{
						name: '最高温度',
						type: 'line',
						smooth: true,
						animation: false,
						lineStyle: {
							width: 2
						},
						itemStyle: {
							color: '#01B5C4'
						},
						data: _this.maxTempList,
					}, {
						name: '最低温度',
						type: 'line',
						smooth: true,
						animation: false,
						lineStyle: {
							width: 2
						},
						itemStyle: {
							color: '#48CC96'
						},
						data: _this.minTempList,
					}],
				};
				_this.tempchart.setOption(option);
				window.addEventListener("resize", function() {
					_this.tempchart.resize();
				});

				var imgSrc = _this.tempchart.getDataURL();
				$('#temperatureimg').attr('src', imgSrc).show();
				$('#temperatureimg').css('display', 'none');
			},
			//电压极差
			onVoltageRange: function() {
				let _this = this;
				_this.voltagechart2 = this.$echarts.init(document.getElementById('voltageRange'));
				var option = {
					title: {
						show: false,
						text: '电压极差变化曲线',
						left: 'center',
					},
					tooltip: {
						trigger: 'axis',
						axisPointer: {
							lineStyle: {}
						}
					},
					legend: {
						icon: 'rect',
						itemWidth: 8,
						itemHeight: 8,
						itemGap: 10,
						data: ['电压极差'],
						right: '10px',
						top: '0px',
						textStyle: {
							fontSize: 12,
						}
					},
					grid: {
						x: 50,
						y: 50,
						x2: 45,
						y2: 40
					},
					xAxis: [{
						type: 'category',
						boundaryGap: false,
						axisTick: {
							show: false,
						},
						axisLine: {
							lineStyle: {
								color: '#909399'
							}
						},
						axisLabel: {

							formatter: function(value, index) {
								var date = new Date(value);
								var texts = [(date.getHours()), date.getMinutes(), date.getSeconds()];
								return texts.join(':');
							}
						},
						data: _this.voltageTimeList
					}],
					yAxis: [{
						type: 'value',
						// boundaryGap: [0, '100%'],
						name: '单位（ V ）',
						nameLocation: 'center',
						nameTextStyle: {
							padding: 5
						},
						axisTick: {
							show: false
						},
						axisLine: {
							lineStyle: {
								color: '#57617B'
							}
						},
						axisLabel: {
							margin: 10,

							fontSize: 12,
							formatter: '{value}'
						},
						splitLine: {
							lineStyle: {
								color: '#e5e5e5'
							}
						}
					}],

					series: [{
						name: '电压极差',
						type: 'line',
						smooth: true,
						animation: false,
						lineStyle: {
							width: 2
						},
						yAxisIndex: 0,
						itemStyle: {
							color: '#48CC96'
						},
						data: _this.voltageRangeList,
					}],
				};
				_this.voltagechart2.setOption(option);
				window.addEventListener("resize", function() {
					_this.voltagechart2.resize();
				});
				var imgSrc = _this.voltagechart2.getDataURL();
				$('#voltageRangeimg').attr('src', imgSrc).show();
				$('#voltageRangeimg').css('display', 'none');
			},
			//温度极差
			onTemperatureRange: function() {
				let _this = this;
				_this.tempchart2 = this.$echarts.init(document.getElementById('temperatureRange'));
				var option = {
					title: {
						show: false,
						text: '温度极差变化曲线',
						left: 'center',
					},
					tooltip: {
						trigger: 'axis',
						axisPointer: {
							lineStyle: {}
						}
					},
					legend: {
						icon: 'rect',
						itemWidth: 8,
						itemHeight: 8,
						itemGap: 10,
						data: ['温度极差'],
						right: '10px',
						top: '0px',
						textStyle: {
							fontSize: 12,
						}
					},
					grid: {
						x: 50,
						y: 50,
						x2: 45,
						y2: 40
					},
					xAxis: [{
						type: 'category',
						boundaryGap: false,
						axisTick: {
							show: false,
						},
						splitLine: {

						},
						axisLine: {
							lineStyle: {
								color: '#909399'
							}
						},
						axisLabel: {
							formatter: function(value, index) {
								var date = new Date(value);
								var texts = [(date.getHours()), date.getMinutes(), date.getSeconds()];
								return texts.join(':');
							}
						},
						data: _this.tempTimeList,
					}],
					yAxis: [{
						type: 'value',
						name: '单位（ ℃ ）',
						nameLocation: 'center',
						nameTextStyle: {
							padding: 5
						},
						axisTick: {
							show: false
						},
						axisLine: {
							lineStyle: {
								color: '#57617B'
							}
						},
						axisLabel: {
							margin: 10,
							fontSize: 12,
							formatter: '{value}'
						},
						splitLine: {
							lineStyle: {
								color: '#e5e5e5'
							}
						}
					}],
					series: [{
						name: '温度极差',
						type: 'line',
						smooth: true,
						animation: false,
						lineStyle: {
							width: 2
						},
						itemStyle: {
							color: '#48CC96'
						},
						data: _this.tempRangeList,
					}],
				};
				_this.tempchart2.setOption(option);
				var imgSrc = _this.tempchart2.getDataURL();
				$('#temperatureRangeimg').attr('src', imgSrc).show();
				$('#temperatureRangeimg').css('display', 'none');

				window.addEventListener("resize", function() {
					_this.tempchart2.resize();
				});

			},

			onformat: function(data) {
				let _this = this;
				_this.form = {
					recordCode: data.recordCode,
					stationName: data.stationName,
					beginTime: data.beginTime,
					endTime: data.endTime,
					gunNo: data.gunNo,
					pileCode: data.pileCode,
					recordCode: data.recordCode,
					stationName: data.stationName,
					beginTime: data.beginTime,
					endTime: data.endTime,
					gunNo: data.gunNo,
					pileCode: data.pileCode,
					plateNumber: data.plateNumber,
					carType: data.carType,
					vin: data.vin,
					batteryType: data.batteryType,
					score: data.score,
					suggest: data.suggest,
					consistency: data.consistency,
					capacityMetrics: data.capacityMetrics,
					energyIndicator: data.energyIndicator,
					thermalRunaway: data.thermalRunaway,
					failureMetrics: data.failureMetrics,
				};

				_this.maxTempList = data.singleTempInfo.singleMaxTemp;
				_this.minTempList = data.singleTempInfo.singleMinTemp;
				_this.tempTimeList = data.singleTempInfo.dateTime;
				_this.tempRangeList = data.singleTempInfo.tempRange;


				_this.maxVoltageList = data.singleVoltageInfo.singleMaxVoltage;
				_this.minVoltageList = data.singleVoltageInfo.singleMinVoltage;
				_this.voltageTimeList = data.singleVoltageInfo.dateTime;
				_this.voltageRangeList = data.singleVoltageInfo.voltageRange;


				this.$nextTick(() => {

					_this.onThermalRunaway();

					_this.onTemperature();
					_this.onVoltage();

					_this.onVoltageRange();
					_this.onTemperatureRange();

					_this.onRadar();
					_this.onRadar2();
					_this.onRadar3();

				})

			},
			onThermalRunaway: function() {
				let _this = this;
				let myChart2 = this.$echarts.init(document.getElementById('thermalRunaway'));
				var colorList2 = ['#01AE4F', '#FDFE01', '#FD0101', '#BF0202']
				var colorList = [{
					x: 0,
					y: 1,
					x2: 0,
					y2: 0,
					colorStops: [{
						offset: 0,
						color: '#01AE4F' // 0% 处的颜色
					}, {
						offset: 1,
						color: '#01AE4F' // 100% 处的颜色
					}],
				}, {
					x: 0,
					y: 1,
					x2: 0,
					y2: 0,
					colorStops: [{
						offset: 0,
						color: '#FDFE01' // 0% 处的颜色
					}, {
						offset: 1,
						color: '#FDFE01' // 100% 处的颜色
					}],
				}, {
					x: 0,
					y: 1,
					x2: 0,
					y2: 0,
					colorStops: [{
						offset: 0,
						color: '#FD0101' // 0% 处的颜色
					}, {
						offset: 1,
						color: '#FD0101' // 100% 处的颜色
					}],
				}, {
					x: 0,
					y: 1,
					x2: 0,
					y2: 0,
					colorStops: [{
						offset: 0,
						color: '#BF0202' // 0% 处的颜色
					}, {
						offset: 1,
						color: '#BF0202' // 100% 处的颜色
					}],
				}];

				let value = 0;
				switch (_this.form.thermalRunaway) {
					case '0':
						value = 0.5;
						break;
					case '1':
						value = 1.5;
						break;
					case '2':
						value = 2.5;
						break;
					case '3':
						value = 3.5;
						break;
				}

				var option = {

					series: [{
						type: 'gauge',
						splitNumber: 3,
						radius: '93%',
						center: ["50%", "60%"],
						startAngle: 180,
						endAngle: 0,
						min: 0,
						max: 4,
						pointer: {
							show: true,
							width: 7,
							itemStyle: {
								color: colorList2[parseInt(value)],
							},
							length: "60%",
							borderColor: '#000',
							borderWidth: '10',
						},
						axisLine: {
							show: true,
							lineStyle: {
								width: 35,
								color: [
									[0.25, colorList[0]],
									[0.5, colorList[1]],
									[0.75, colorList[2]],
									[1, colorList[3]],
								],
								borderColor: '#000',
								borderWidth: '10',
							},
						},
						axisLabel: {
							show: false,
							color: "#666",
							fontSize: 16,
							formatter: function(value) {
								return value.toFixed(0);
							},
						}, //刻度标签。
						axisTick: {
							show: false,

						}, //刻度样式            
						splitLine: {
							show: false,
							length: "28%",
							lineStyle: {
								color: "#fff",
								width: 2,
							},
						}, //分隔线样式
						detail: {
							show: false
						},
						title: {
							show: false
						},
						data: [{
							value: value,
						}],

					}, {
						type: 'gauge',
						splitNumber: 10,
						radius: '100%',
						center: ["50%", "60%"],
						min: 0,
						max: 4,
						startAngle: 180,
						endAngle: 0,
						pointer: {
							show: false,
							width: 7,
							length: "60%"
						},
						axisLine: {
							show: true,
							lineStyle: {
								width: 35,
								color: [
									[0.25, colorList[0]],
									[0.5, colorList[1]],
									[0.75, colorList[2]],
									[1, colorList[3]],
								],
								opacity: 0.15,
								borderColor: '#000',
								borderWidth: '10',
							},
						},
						axisLabel: {
							show: false,
						}, //刻度标签。
						axisTick: {
							show: false,
							splitNumber: 5,
							lineStyle: {
								color: "#fff",
								width: 2,
							},

						}, //刻度样式            
						splitLine: {
							show: false,
							length: "28%",
							lineStyle: {
								color: "#fff",
								width: 2,
							},
						}, //分隔线样式
						detail: {
							show: false
						},
						title: {
							show: false
						},
						data: [{
							value: 2,
							name: ''
						}],
					}, { // 内侧刻度
						type: 'gauge',
						radius: '75%', // 位置
						center: ["50%", "60%"],
						min: 0,
						max: 200,
						startAngle: 180,
						endAngle: 0,
						axisLine: {
							show: false,
							lineStyle: {
								width: 4, // 宽度
							},
						},
						axisTick: {
							// 刻度
							show: true,
							splitNumber: 4,
							length: 5,
							lineStyle: {
								width: 2,
								color: '#e5e5e5',
							},
						},
						splitLine: {
							// 分割线
							show: false,
						},
						axisLabel: {
							// 刻度标签
							show: false,
						},
						pointer: {
							// 仪表盘指针
							show: false,
						},
						detail: {
							// 仪表盘详情
							show: false,
						},
					}, { // 数据
						type: 'gauge',
						radius: '100%', // 位置
						center: ["50%", "60%"],
						min: 0,
						max: 4,
						startAngle: 180,
						endAngle: 0,
						axisLine: {
							show: true,
							lineStyle: {
								// 轴线样式
								width: 45, // 宽度
								opacity: 0.9,
								color: [
									[0.25, colorList2[0]],
								], // 颜色
							},
						},
						pointer: {
							// 仪表盘指针
							show: false,
						},
						axisLine: {
							show: false,
							lineStyle: {
								width: 2, // 宽度
							},
						},
						axisTick: {
							// 刻度
							show: true,
							splitNumber: 4,
							length: 10,
							lineStyle: {
								width: 2,
								color: '#e5e5e5',
							},
						},
						splitLine: {
							// 分割线
							show: false,
						},
						axisLabel: {
							// 刻度标签
							show: false,
						},
						detail: {
							// 仪表盘详情
							show: false,
						},
					}]
				};

				myChart2.setOption(option, true);
				window.addEventListener("resize", function() {
					myChart2.resize();
				});
				var imgSrc = myChart2.getDataURL();
				$('#thermaldiv').attr('src', imgSrc).show();
				$('#thermaldiv').css('display', 'none');

				setTimeout(function() {
					var imgSrc = myChart2.getDataURL();
					$('#thermaldiv').attr('src', imgSrc).show();
					$('#thermaldiv').css('display', 'none');
				}, 2000);
			},

			getPdf() {
				var title = '报告_' + new Date().toLocaleString(); // 导出的pdf文件名
				html2Canvas(document.querySelector('#pdfPrint'), { //导出的html元素
					allowTaint: true
				}).then(function(canvas) {
					let contentWidth = canvas.width;
					let contentHeight = canvas.height;
					let pageHeight = contentWidth / 592.28 * 841.89;
					let leftHeight = contentHeight;
					let position = 0;
					let imgWidth = 595.28;
					let imgHeight = 592.28 / contentWidth * contentHeight;
					let pageData = canvas.toDataURL('image/jpeg', 1.0);
					let PDF = new JsPDF('', 'pt', 'a4');
					if (leftHeight < pageHeight) {
						PDF.addImage(pageData, 'JPEG', 0, 0, imgWidth, imgHeight);
					} else {
						while (leftHeight > 0) {
							PDF.addImage(pageData, 'JPEG', 0, position, imgWidth, imgHeight);
							leftHeight -= pageHeight;
							position -= 841.89;
							if (leftHeight > 0) {
								PDF.addPage();
							}
						}
					}
					PDF.save(title + '.pdf');
				})
			},
		},
		watch: {
			formPrint: function(newValue, oldValue) {
				console.log("formPrint:", newValue);

				this.onformat(newValue);

				this.$emit('feedback', '200', '2');
			},
		}
	}
</script>

<style lang="scss">
	html,
	body,
	#app {
		height: auto !important;
		background: white;
		-webkit-print-color-adjust: exact;
	}

	.main {
		background-color: white !important;
	}

	@media print {
		#app {
			background-color: white !important;
		}

		div.allnav,
		.noprint {
			display: none;
			background-color: white !important;
		}

		img.allnav {
			display: inline !important;
		}

		.el-descriptions-item__content,
		span,
		b,
		p,
		* {
			color: #606266 !important;
		}



		.div4,
		.div5,
		.div6,
		.div7 {
			img.allnav {
				position: absolute;
				width: calc(100% - 335px) !important;
				height: 280px !important;
				right: 50px;
			}

			.title {
				position: absolute;
				left: 0px;
				width: 280px !important;
				height: 280px !important;
			}
		}

		.div3,
		.div7 {
			margin: 50px 0px !important;
		}

		.div2 {
			img.allnav {
				width: 33% !important;
				height: 280px !important;
			}
		}

		.div3 {
			img.allnav {
				width: 100% !important;
				height: 280px !important;
			}
		}

		.div1 {
			.sp1,
			.sp2,b {
				color: #00A17F !important;
			}
		}
	}


	.exportReport {
		margin: auto;
		width: 100%;
		max-width: 1100px;
		background-color: white !important;
		padding: 30px 20px;

		.noprint {
			position: fixed;
			right: 15%;
			top: 50%;
			z-index: 99999;
		}

		.el-descriptions {
			margin: 40px 0px;
		}

		.allnav {
			width: 770px;
			height: 280px;
			min-height: 280px;
		}


		.topdiv {
			background-image: url('../assets/images/a.jpg');
			background-repeat: no-repeat;
			width: 100%;
			height: 600px;
			text-align: center;
			line-height: 200px;
			padding: 20px 0px;
			background-position: center;
			background-size: 100% auto;
		}

		.div1,
		.div2,
		.div3,
		.div4,
		.div5,
		.div6,
		.div7 {
			margin: 20px 20px;
			background-image: url('../assets/images/c.png');
			background-size: 100% 100%;
			background-repeat: no-repeat;
			padding: 20px 50px 50px 0px;
			position: relative;

		}

		.div1 {
			background-image: url('../assets/images/b.png');
			background-size: 100% 100%;
			background-repeat: no-repeat;
			padding: 20px 50px 50px 0px;
			height: 450px;
			position: relative;
			margin-bottom: 50px;

			ul {
				list-style: none;
				margin: 0 auto;
				padding: 0px;
				width: 75%;
				margin-top: 70px;

				li {
					display: inline-block;
					width: 55%;
					line-height: 30px;
					letter-spacing: 2px;

					color: #606266;
					font-weight: bold;
					font-family: fangsong;


					&:nth-child(even) {
						width: 45%;
					}
				}
			}

			.scorediv {
				width: 75%;
				height: 80px;
				background-color: #DEFAFC;
				background-image: linear-gradient(#DEFAFC, #F8FCFB);
				margin: 0 auto;
				margin-top: 20px;
				position: relative;

				.sp1 {
					line-height: 70px;
					margin-left: 50px;
					font-size: 18px;
					color: #00A17F;
					font-weight: bold;
					font-family: fangsong;
				}

				b {
					font-size: 36px;
					margin: 20px;
					color: #00A17F;
					font-weight: 500;
					font-weight: bold;
					font-family: fangsong;
				}

			}

			.sp2 {
				font-size: 14px;
				color: #00A17F;
				text-align: right;
				width: 75%;
				margin: 0 auto;
				margin-top: 10px;
			}
		}

		.div2 {
			display: flex;
			flex-direction: row;
			justify-content: space-around;
			align-items: flex-start;
			height: 350px;
			position: relative;
			margin-bottom: 100px;
			margin: 30px 0px 0px;


			p {
				font-size: 18px;
				text-align: right;
				color: #606266;
				font-weight: bold;
				font-family: fangsong;
			}

			.sp1 {
				position: absolute;
				bottom: 20px;
				left: 10%;
			}

			.sp2 {
				position: absolute;
				bottom: 20px;
			}

			.sp3 {
				position: absolute;
				bottom: 20px;
				right: 15%;
			}

			img.allnav {
				display: none;
			}
		}

		.div3 {
			padding: 0px;
			position: relative;
			margin: 30px 0px 0px;


			.allnav {
				width: 100%;
				height: 300px;
				min-height: 300px;
			}

			p {
				width: 100%;
				font-size: 18px;
				color: #606266;
				left: 30px;
				position: absolute;
				top: 30px;
			}

			ul {
				position: absolute;
				bottom: 60px;
				margin: auto;
				left: 0px;
				right: 0px;
				width: max-content;

				li {
					display: inline-block;
					margin: 0px 20px;
					color: #606266;
					font-weight: bold;
					font-family: fangsong;
					font-size: 16px;

					span {
						display: inline-block;
						width: 15px;
						height: 7px;
						border-radius: 5px;
						background-color: #01AE4F;
						vertical-align: middle;
						margin-right: 10px;

					}

					&:nth-child(2) span {
						background-color: #FDFE01;
					}

					&:nth-child(3) span {
						background-color: #FD0101;
					}

					&:nth-child(4) span {
						background-color: #BF0202;
					}
				}
			}

			img.allnav {
				display: none;
			}
		}

		.div4,
		.div5,
		.div6,
		.div7 {

			display: flex;
			flex-direction: row;
			justify-content: space-around;
			align-items: flex-start;
			height: 350px;
			margin: 30px 0px;



			img.allnav {
				position: absolute;
				width: 725px;
				right: 50px;
				display: none;
			}


			.title {
				width: 30%;
				height: 100%;
				display: flex;
				flex-direction: column;
				justify-content: space-around;
				align-items: center;
				align-content: space-around;

				p {
					margin: 0px;
					width: 70%;
					color: #909399;
					font-weight: bold;
					font-family: fangsong;
					font-size: 16px;

					&:nth-child(1) {
						width: 100%;
						font-size: 18px;
						text-align: right;
						color: #606266;
					}
				}

			}

		}

		.div3,
		.div7 {
			margin-top: 150px;
		}

	}
</style>
